import { Button, Classes, Dialog, Intent } from '@blueprintjs/core';
import * as React from 'react';

export interface WarningDialogLabels {
  content: string;
  title: string;
  validateButton: string;
}

interface WarningDialogProps {
  dialogLabels: WarningDialogLabels;
  isOpen: boolean;
  close: () => void;
}

export const WarningDialog = ({ dialogLabels, isOpen, close }: WarningDialogProps) => {
  const closeDialog = () => {
    close();
  };

  return (
    <Dialog isOpen={isOpen} title={dialogLabels.title} onClose={closeDialog} canOutsideClickClose={false}>
      <div className={Classes.DIALOG_BODY}>{dialogLabels.content}</div>
      <div className={Classes.DIALOG_FOOTER}>
        <div className={Classes.DIALOG_FOOTER_ACTIONS}>
          <Button
            onClick={() => {
              closeDialog();
            }}
            intent={Intent.PRIMARY}
          >
            {dialogLabels.validateButton}
          </Button>
        </div>
      </div>
    </Dialog>
  );
};
